export const TableHelpers = {
    data() {
      return {
        tableColumns: [
          {
            title: "Expediente",
            type: "custom-html",
            key: "record",
            modifier: (value, row) => {
              return `<a href="/accreditations/applications/${
                row.id
              }" target="_blank">${value || ""}</a>`;
            },
          },
          {
            title: this.$t("Tipo Solicitud"),
            type: "custom-html",
            key: "accreditation_activity",
            modifier: (value) => {
              return value.name;
            },
          },
          {
            title: this.$t("Tipo acreditación"),
            type: "custom-html",
            key: "accreditation_type",
            modifier: (value) => {
              return value.name;
            },
          },
          {
            title: "OEC",
            type: "custom-html",
            key: "organization",
            modifier: (value) => {
              return value.business_name;
            },
          },
          {
            title: "Estado",
            type: "custom-html",
            key: "is_active",
            isVisible: true,
            modifier: (item) => {
              let className = "success";
              let status = "Activo";
              if (item == 0) {
                className = "danger";
                status = "Inactivo";
              }
              return `<span class="badge badge-sm badge-pill badge-${className}">${status}</span>`;
            },
          },
          {
            title: "Estado Certificado",
            type: "custom-html",
            key: "send_certificate",
            modifier: (item, row) => {
              let tmp;
              if (row.send_certificate && row.certificate_accreditation_symbol) {
                tmp = `<span class="badge badge-sm badge-pill badge-success">Enviado</span>`;
              } else if (row.certificate_accreditation_symbol && !row.send_certificate) {
                tmp = `<span class="badge badge-sm badge-pill badge-success">Generado</span>`;
              }
              else {
                tmp = "";
              }
              return tmp;
            }
            
          },
          /* {
            title: "Días Disponibles",
            type: "custom-html",
            key: "accreditation_time",
            modifier: (value) => {
              let tmp;
              if (value) {
                if (value.remaining_days > 0) {
                  tmp = `<span class="badge badge-sm badge-pill badge-success">${value.remaining_days}</span>`;
                } else {
                  tmp =
                    '<span class="badge badge-sm badge-pill badge-danger">Días Vencidos</span>';
                }
              }
              return tmp;
            },
          }, */
        ],
        actionObj: {
          title: this.$t("action"),
          type: "action",
        },
      };
    },
  };